// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SectionLayout_wrap_3vGYf","title_wrap":"SectionLayout_title_wrap_1qwJH","title":"SectionLayout_title_1V_M6","sub_title":"SectionLayout_sub_title_2C4lw"};